import { useLocation } from "react-router-dom";
import PortalSubnav from "./PortalSubnav";
import { useAuth } from "@/context/AuthContext";

/**
 * PortalShell — renders the portal sub-nav ONLY when the user is logged in
 * and NOT on the public landing / auth pages. Keeps the site header/footer
 * from Layout intact (visual integration with main site).
 */
export default function PortalShell({ children }) {
    const { isAuthenticated } = useAuth();
    const { pathname } = useLocation();
    const hideSubnavRoutes = new Set([
        "/portal",
        "/portal/login",
        "/portal/signup",
    ]);
    const showSubnav = isAuthenticated && !hideSubnavRoutes.has(pathname);

    return (
        <>
            {showSubnav && <PortalSubnav />}
            {children}
        </>
    );
}
